import controller from './search-appointment.controller';
import template from './search-appointment.html';
import './search-appointment.css';

const SearchAppointmentComponent = {
    bindings: {
    },
    controller,
    template,
};

export default SearchAppointmentComponent;


//////////////////
// WEBPACK FOOTER
// ./src/health-care-book/search-appointment/search-appointment.component.js
// module id = 634
// module chunks = 0